window.dataLayer = window.dataLayer || [];

export const GTM_ID = process.env.REACT_APP_GTM_ID
export const GTAG_ID = process.env.REACT_APP_GTAG_ID

export const gtag = (...args) => {
  window.dataLayer.push(args);
};

export const isGTMAvailable = () => {
  return !!(GTM_ID && window.dataLayer);
};

export const isGtagAvailable = () => {
  return !!(GTAG_ID && window.gtag);
};

export const sendGTMEvent = (eventData) => {
  if (isGTMAvailable()) {
    window.dataLayer.push(eventData);
  }
};

export const sendGtagEvent = (eventName, parameters = {}) => {
  if (isGtagAvailable()) {
    window.gtag('event', eventName, parameters);
  }
};

export const trackPageView = (pageData) => {
  const { title, location, path } = pageData;  
  sendGTMEvent({
    event: 'page_view',
    page_title: title,
    page_location: location,
    page_path: path
  });

  if (isGtagAvailable()) {
    window.gtag('config', process.env.REACT_APP_GTAG_ID, {
      page_title: title,
      page_location: location,
      page_path: path
    });
  }
};

export const trackEvent = (eventName, parameters = {}) => {
  sendGTMEvent({
    event: eventName,
    ...parameters
  });
  
  sendGtagEvent(eventName, parameters);
};